export function noop() {}

export function noopAsync() {
  return Promise.resolve()
}

export function noopReturn<T>(v: T): T {
  return v
}
